// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v3AsX","importantInfo":"styles_importantInfo__279-w"};